var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup43(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.509,
    height: 110.126,
    viewBox: "0 0 174.509 110.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(844.128 -1851.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M212,887.4v63.534a11.144,11.144,0,0,0,11.143,11.144H375.364a11.144,11.144,0,0,0,11.143-11.144V887.4Zm110.237,60.643a2.536,2.536,0,0,1-2.536,2.537H225.175a2.537,2.537,0,0,1-2.537-2.537v-5.26a2.536,2.536,0,0,1,2.537-2.536H319.7a2.535,2.535,0,0,1,2.536,2.536Zm0-34.866a3.182,3.182,0,0,1-3.182,3.182H225.82a3.182,3.182,0,0,1-3.182-3.182v-9.9a3.182,3.182,0,0,1,3.182-3.182h93.234a3.182,3.182,0,0,1,3.182,3.182Zm22.279-.421a3.6,3.6,0,0,1-3.6,3.6h-9.056a3.6,3.6,0,0,1-3.6-3.6V903.7a3.6,3.6,0,0,1,3.6-3.6h9.056a3.6,3.6,0,0,1,3.6,3.6Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M386.507,872.282v-9.187a11.144,11.144,0,0,0-11.144-11.144H223.142A11.144,11.144,0,0,0,212,863.095v9.187Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup43);
export default __webpack_public_path__ + "static/media/Group 43.e0ffd7ccf9248dc9f50890f42691fb97.svg";
export { ForwardRef as ReactComponent };